import styled from "styled-components";
import { CarouselItemThemeAttributes } from "../attributes/CarouselItemTheme";
import { Attribute, AttributeGroup, AttributeProperty, ComponentProps } from "react-builder";
import { useEffect, useRef, useState } from "react";

@AttributeGroup({ title: "CarouselItem", blockName: "CarouselItem", icon: "async-image" })
export class CarouselItemAttributes extends Attribute {
  @AttributeProperty({ type: "Object", cssTarget: ".carousel-item" })
  itemTheme: CarouselItemThemeAttributes = new CarouselItemThemeAttributes();
}

const CarouselItemTheme = styled.div(
  (props: { attributes: CarouselItemAttributes }) => `
      min-width: 175px;
    ${props.attributes.toCSS()}

`
);

export function CarouselItem(props: ComponentProps<CarouselItemAttributes>) {
  const parentRef = useRef(null);
  const [isParentInView, setIsParentInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsParentInView(entry.isIntersecting);
    });

    if (parentRef.current) {
      observer.observe(parentRef.current);
    }

    return () => {
      if (parentRef.current) {
        observer.unobserve(parentRef.current);
      }
    };
  }, []);
  return (
    <CarouselItemTheme
      {...props}
      className="carousel-item"
      attributes={props.attributes}
      ref={parentRef}
    >
      {isParentInView && <>{props.children}</>}
    </CarouselItemTheme>
  );
}

CarouselItem.prototype.Props = CarouselItemAttributes;

export default CarouselItem;
